<template>
  <div>
    <my-breadcrumb :items="pagination"></my-breadcrumb>
    <div class="forum-container">
      <div class="aalign-end aspace-between">
        <div class="aalign-start">
          <h6 @click="goToClassForum" style="cursor: pointer;">
            <fa-icon icon="long-arrow-alt-left" class="mr-1"></fa-icon> Kembali Ke Forum
          </h6>
        </div>
      </div>

      <div class="forum-content pd-22">
        <h4 class="mrb-0">
          Notification
        </h4>
        <div class="discussions">
          <div class="discussion text-center" style="display: block;" v-if="newNotif > 0">
            <div class="discussion__comments-count" v-if="loadingNew">
              <b-spinner small label="Loading"></b-spinner>
            </div>
            <div class="discussion__comments-count" style="cursor: pointer;" @click="loadNew">
              {{ newNotif}} New Notif(s)
            </div>
          </div>
          <div
            class="discussion"
            v-for="(item, i) in notifs"
            :key="i"
          >
            <div class="discussion__left">
              <img src="/img/avatars/user-avatar4.png" alt="avatar" />
            </div>

            <div class="discussion__middle">
              <p class="forum_p">
                <div v-if="item.type == 'forum_reply'">
                  <a href="#">{{item.user_name}}</a>
                  menjawab pertanyaan forum 
                  <a href="#">{{item.target_name}}</a>
                </div>
                <div v-else>
                  <a href="#">{{item.user_name}}</a> {{ item.type }}
                </div>
              </p>
              <span class="discussion__time">
                {{ $helpers.formatDateTimeID(item.created_at) }}
              </span>
            </div>

            <div class="discussion__right">
              <my-button @click="goToForumDetail(item)">
                View
              </my-button>
            </div>
          </div>

          <div v-if="notifs.length ==0" class="text-center mt-4">
            <img src="/img/icons/warningexam.png" width="65" />
            <br>
            <small class="color-1">Empty Notif</small>
          </div>
        </div>

        <div class="text-center mt-4" v-if="loadMore && loading">
          <my-button>
            <b-spinner small label="Loading"></b-spinner>
          </my-button>
        </div>
        <div class="text-center mt-4" v-else-if="loadMore" @click="getNotif">
          <my-button>
            Load More
          </my-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";

export default {
  data() {
    return {
      notifs: [],
      loading: false, 
      loadingNew: false,
      loadMore: false, 
      limit: 10, 
      offset: 0
    };
  },
  props: {
    collapsed: {
      default: false
    }
  },
  computed: {
    ...mapGetters({
      isLoggedIn: types.IS_LOGGED_IN, 
      user: types.USER,
      section: types.SECTION, 
      newNotif: types.NEW_NOTIF
    }),
    pagination() {
      var data = [
        {
          text: this.section.level,
          url: '#'
        },
        {
          text: this.section.class + " "+ this.section.major ? this.section.class : "",
          url: '#'
        },
        {
          text: this.section.subject,
          url: '#'
        },
        {
          text: this.section.curriculum,
          url: '#'
        },
        {
          text: this.section.chapter,
          url: '#'
        },{
          text: this.section.name,
          url: '#'
        }
      ]

      return data
    }
  },
  mounted() {
    if(this.isLoggedIn) {
      if(this.$route.params.section && this.$route.params.section != this.section.id) {
        this.$router.push('/class/' + this.$route.params.section)
      } else if(!this.$route.params.section && !this.section.id) {
        this.$router.push("/no-subject");
      } else {
        this.setOverlay(true);
        this.getNotif()
      }
    } else {
      var link = "/login"
      if(this.$route.params.section) {
        link += "?section=" + this.$route.params.section
      }
      this.$router.push(link);
    }
  }, 
  methods: {
    ...mapActions({
      notifList: types.NOTIF_LIST,
      setOverlay: types.SET_OVERLAY,
      updateNotif: types.UPDATE_NOTIF,
    }),
    loadNew() {
      this.offset = 0
      this.getNotif()
    },
    getNotif() {
      if(this.offset == 0) {
        this.loadingNew = true
      }
      this.loading = true
      var payload = {
        params: { 
          limit: this.limit, 
          offset: this.offset
        }
      }

      this.notifList(payload)
      .then((response) => {
        this.setOverlay(false);
        this.loading = false
        if(this.offset == 0) {
          this.loadingNew = false
          this.updateNotif(0)
          this.notifs = []
        }

        for (var i = 0; i < response.length; i++) {
          this.notifs.push(response[i])
        }

        if(response.length < this.limit) {
          this.loadMore = false
        } else {
          this.loadMore = true
        }

        this.offset = this.notifs.length
      })
      .catch((error) => {
        this.setOverlay(false);
        this.loading = false
        this.loadingNew = false
        this.$bvToast.toast('Gagal memuat daftar notif', {
          title: 'Success',
          autoHideDelay: 3000, 
          toaster: 'b-toaster-top-center',
          variant: 'danger'
        })
      });
    },
    goToClassForum() {
      this.$router.push('/class/' + this.section.id + '/forum')
    },
    goToForumDetail(item) {
      this.$router.push('/forum/'+item.target_id)
    }
  }
}
</script>

<style>
.hidden-input {
  width: 1px;
  opacity: 0;
}

.forum-container {
  padding: 27px;
}

.forum-content {
  padding: 24px 23.8px 43.5px 25.8px;
  background-color: #ffffff;
}

.forum_p {
  font-size: 12px;
}

#add-modal .modal-dialog {
  max-width: 936px;
}
</style>
